import React from "react";

import OpenSvg from "../../assets/images/icons/open_blue.svg";

export const OpenBlueIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={OpenSvg}
        alt={alt || "Open"}
    />
);
